<template>
  <component
    component-name="btn"
    :is="
      computedAttributes.is === 'NuxtLink' ? NuxtLink : computedAttributes.is
    "
    :title="title"
    :disabled="computedAttributes.is === 'button' && disabled ? disabled : null"
    :to="
      computedAttributes.is === 'NuxtLink' && computedAttributes.to
        ? `/${$route.params.locale}${computedAttributes.to}`
        : undefined
    "
    :href="
      computedAttributes.is === 'a' && computedAttributes.href
        ? computedAttributes.href
        : undefined
    "
    :target="
      computedAttributes.is === 'a' && computedAttributes.target
        ? computedAttributes.target
        : undefined
    "
    :tabindex="!computedAttributes.is !== 'button' && disabled ? '-1' : 0"
    class="group"
    :class="{
      '!pointer-events-none': disabled,
    }"
    @click="handleClick($event)"
  >
    <slot
      :title="title"
      :icon="useIcon ? (icon ? icon : computedAttributes.icon) : undefined"
      :size="size"
      :disabled="disabled"
      :pressed="pressed"
    />

    <Teleport 
      to="body" 
      :disabled="!isOpen"
    >
      <modal-video 
        v-if="computedAttributes.video"
        :is-open="computedAttributes.video && isOpen"
        :video-url="computedAttributes.video.url"
        @close="isOpen = false"
        @open="isOpen = true"
      />

      <modal-gallery
        v-if="computedAttributes.gallery"
        :is-open="computedAttributes.gallery && isOpen" 
        :list="computedAttributes.gallery"
        @close="isOpen = false"
        @open="isOpen = true"
      />
    </Teleport>
  </component>
</template>

<script setup>
let NuxtLink;

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: false,
  },
  size: {
    type: String,
    required: false,
    default: "regular",
    validator: function (value) {
      return ["small", "regular"].indexOf(value) !== -1;
    },
  },
  disabled: {
    type: Boolean,
    required: false,
  },
  pressed: {
    type: Boolean,
    required: false,
  },
  action: {
    type: Object,
    required: false,
  },
  useIcon: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const isOpen = ref(false);

const computedAttributes = computed(() => {
  let obj = {
    is: "button",
  };

  if (props.action) {
    if (props.action.to) {
      NuxtLink = resolveComponent("NuxtLink");
      obj.is = "NuxtLink";
      obj.to = props.action.to;
      obj.icon = "arrow-right";
    } else if (
      props.action.href_blank ||
      props.action.mailto ||
      props.action.tel
    ) {
      obj.is = "a";

      if (props.action.href_blank) {
        obj.href = props.action.href_blank;
        obj.icon = "arrow-right";
        obj.target = "_blank";
      } else if (props.action.mailto) {
        obj.href = `mailto:${props.action.mailto}`;
        obj.icon = "arrow-right";
      } else if (props.action.tel) {
        obj.href = `tel:${props.action.tel}`;
        obj.icon = "arrow-right";
      }
    } else if (props.action.gallery || props.action.video) {
      obj.icon = "plus";

      if (props.action.gallery) {
        obj.gallery = props.action.gallery;
      } else if (props.action.video) {
        obj.video = props.action.video;
      } 
    }
  }

  return obj;
});

function handleClick(event) {
  if (props.action?.gallery || props.action?.video) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    isOpen.value = true;
  }
}
</script>
